import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from 'environments/environment';
import {Observable} from 'rxjs';

const httpOptions = {
    headers: new HttpHeaders({
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/json'
    })
};

@Injectable({
    providedIn: 'root'
})
export class EstadoArtigosService {
    baseUrl: string;

    constructor(private http: HttpClient) {
        this.baseUrl = `${environment.apiArtigos}`;
    }

// Estados
    getEstados(idClassificacao: number) {
        return this.http.get<any>(this.baseUrl + 'estado/' + idClassificacao, httpOptions);
    }

    getEstado(idEstado: number): Observable<any> {
        return this.http
            .get(this.baseUrl + 'estado/get/' + idEstado, httpOptions);
    }

    getTodosEstados(): Observable<any> {
        return this.http
            .get(this.baseUrl + 'estado', httpOptions)
            .pipe();
    }

    gravarEstado(model: any): Observable<any> {
        return this.http
            .post(this.baseUrl + 'estado', model, httpOptions)
            .pipe();
    }

    ActivarDesactivar(model: any): Observable<any> {

        return this.http
            .post(this.baseUrl + 'estado/activarDesactivar', model, httpOptions)
            .pipe();
    }

    gravarEstadoArtigo(model: any): Observable<any> {
        return this.http
            .post(this.baseUrl + 'estado/Artigo', model, httpOptions)
            .pipe();
    }

    eliminarEstado(idEstado: number): Observable<any> {
        return this.http
            .post(this.baseUrl + 'estado/eliminar/', idEstado, httpOptions)
            .pipe();
    }

// Fim Estados
}
